<section aria-label="Historial de contratos" class="my-3">
  <h5>Historial de contratos</h5>
  @if (canUpload) {
    <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
      <label class="btn btn-outline-dark mb-0" [class.disabled]="uploading()">
        Seleccionar PDF
        <input type="file" class="visually-hidden" accept="application/pdf,.pdf"
          aria-label="Seleccionar contrato PDF" [disabled]="uploading()" (change)="selectFile($event)">
      </label>
      @if (selectedFile(); as file) {
        <span class="text-break">{{ file.name }}</span>
        <button type="button" class="btn btn-zazz-dark" [disabled]="uploading() || loading()" (click)="upload()">
          {{ uploading() ? 'Guardando…' : 'Guardar nuevo contrato' }}
        </button>
      }
    </div>
  }
  @if (success()) { <p class="text-success small" role="status">{{ success() }}</p> }
  @if (actionError()) { <p class="text-danger" role="alert">{{ actionError() }}</p> }
  @if (loading()) {
    <p class="text-muted" role="status">Cargando contratos…</p>
  } @else if (error()) {
    <p class="text-danger" role="alert">{{ error() }}
      <button type="button" class="btn btn-link p-0 ms-2" (click)="loadPage(page())">Reintentar</button>
    </p>
  } @else if (!contracts().length) {
    <p class="text-muted">No hay contratos registrados.</p>
  } @else {
    <div class="table-responsive">
      <table class="table table-sm align-middle" aria-label="Versiones del contrato">
        <thead><tr><th>Versión</th><th>Archivo</th><th>Estado</th><th>Fecha de carga</th><th>Fecha de archivo</th><th><span class="visually-hidden">Acciones</span></th></tr></thead>
        <tbody>
          @for (contract of contracts() | paginate: { id: paginationId, itemsPerPage: pageSize, currentPage: page(), totalItems: total() }; track contract.id) {
            <tr>
              <td>{{ contract.version }}</td>
              <td class="text-break">{{ contract.filename }}</td>
              <td>{{ contract.current ? 'Vigente' : contract.status === 'archived' ? 'Archivado' : contract.status }}</td>
              <td>{{ (contract.uploaded_at | date:'dd/MM/yyyy HH:mm') || '—' }}</td>
              <td>{{ (contract.archived_at | date:'dd/MM/yyyy HH:mm') || '—' }}</td>
              <td class="text-end">
                <button type="button" class="btn btn-link btn-sm text-nowrap" (click)="download(contract)"
                  [disabled]="downloadingId() !== null || uploading()" [attr.aria-label]="'Descargar contrato versión ' + contract.version">
                  {{ downloadingId() === contract.id ? 'Descargando…' : 'Descargar PDF' }}
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    @if (total() > pageSize) {
      <pagination-controls [id]="paginationId" previousLabel="Prev." nextLabel="Sig."
        screenReaderPaginationLabel="Paginación del historial de contratos" (pageChange)="loadPage($event)"></pagination-controls>
    }
  }
</section>
